let counters = {}

export default class Counter
{
    constructor(key) {
        this.key = key

        if( counters[this.key] === undefined ) {
            this.reset()
        }
    }

    reset() {
        return counters[this.key] = 0
    }

    increment() {
        return ++counters[this.key]
    }

    decrement() {
        return --counters[this.key]
    }

    get() {
        return counters[this.key]
    }

    key() {
        return this.key
    }

    all() {
        return counters
    }
}
